import React from 'react';

import Button from 'components/Button';
import { openDecagonChat } from 'components/Decagon/Decagon.helpers';
import { HTTP_CLIENT_ERROR_MIN, HTTP_SERVER_ERROR_MIN } from 'constants/http';
import { bem } from 'helpers/class-name';

import { apiErrorSnackbarMessages } from './api-error-snackbar.messages';

const { element } = bem('item-form');

const MAX_PASSTHROUGH_MESSAGE_LENGTH = 200;

export const defaultContactLinkRenderer = chunks => (
  <Button
    onClick={openDecagonChat}
    styled="inline-link"
    className={element('snackbar-link')}
    type={Button.TYPES.BUTTON}>
    {chunks}
  </Button>
);

export function extractApiErrorMessage(error) {
  const data = error?.response?.data;
  if (!data) return null;

  const candidates = [
    data.message,
    data.error?.message,
    typeof data.error === 'string' ? data.error : null,
    data.detail,
    data.errors?.[0]?.message,
  ];

  const message = candidates.find(candidate => typeof candidate === 'string' && candidate.trim());
  return message ? message.trim() : null;
}

export function getErrorSnackbarDescriptionWithContactLink(
  messageDescription,
  contactLinkRenderer = defaultContactLinkRenderer
) {
  return {
    ...messageDescription,
    values: {
      'contact-us-link': contactLinkRenderer,
    },
  };
}

export function getApiErrorSnackbarDescription(error, contactLinkRenderer = defaultContactLinkRenderer) {
  const status = error?.response?.status;
  const backendMessage = extractApiErrorMessage(error);
  const isClientError = status >= HTTP_CLIENT_ERROR_MIN && status < HTTP_SERVER_ERROR_MIN;

  if (isClientError && backendMessage && backendMessage.length <= MAX_PASSTHROUGH_MESSAGE_LENGTH) {
    return {
      ...apiErrorSnackbarMessages.apiErrorPassthrough,
      values: { message: backendMessage },
    };
  }

  if (isClientError) {
    return apiErrorSnackbarMessages.clientErrorDescription;
  }

  return getErrorSnackbarDescriptionWithContactLink(
    apiErrorSnackbarMessages.serverErrorDescription,
    contactLinkRenderer
  );
}
